import { Select } from "@/components/Select";
import Tabs, { ITab } from "@/components/Tabs";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import {
  IHealthCheckHistoryDate,
  getHealthCheckHistoryMonths,
} from "@/utils/dateManager";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";

const HealthCheckHistory = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const months = getHealthCheckHistoryMonths();

  const [searchParams, setSearchParams] = useSearchParams({});

  useEffect(() => {
    if (!searchParams.get("month")) setSearchParams({ month: months[0].value });
  }, []);

  const handleSelectChange = (option: unknown) => {
    const metaOption = option as IHealthCheckHistoryDate;
    if (metaOption) setSearchParams({ month: metaOption?.value });
  };

  const tabs: ITab[] = [
    {
      title: t("sms.healthCheckHistory.tabs.shopify"),
      path: `shopify?month=${searchParams.get("month")}`,
      checkIsActive: () => pathname.includes("shopify"),
    },
    {
      title: t("sms.healthCheckHistory.tabs.klaviyo"),
      path: `klaviyo?month=${searchParams.get("month")}`,
      checkIsActive: () => pathname.includes("klaviyo"),
    },
  ];

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={t("sms.healthCheckHistory.header.feature")}
          headingText={t("sms.healthCheckHistory.header.heading")}
        />
      </TypographyContainer>
      <div className="ml-auto mt-30 max-w-full sm:max-w-[320px]">
        <Select
          label="Month"
          name="healthHistoryMonth"
          defaultValue={months[0]}
          options={months}
          onChange={handleSelectChange}
          closeMenuOnSelect
        />
      </div>
      <div className="mt-2">
        <Tabs tabs={tabs} />
        <div className="mt-50">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default HealthCheckHistory;
